import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography, Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  storeBanner: {
    height: 223,
    width: '100%',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    [theme.breakpoints.up('sm')]: {
      height: 275,
    },
  },
  storeInfoWrapper: {
    display: 'flex',
    padding: '0 9.5px',
    [theme.breakpoints.up('md')]: {
      padding: '0 28px',
    },
  },
  storeContentWrapper: {
    paddingTop: 22,
    paddingLeft: 13.5,
    [theme.breakpoints.up('md')]: {
      paddingTop: 22,
      paddingLeft: 17.5,
    },
  },
  avatar: {
    width: 80,
    height: 80,
    border: '4px solid #F4F5F8',
    backgroundColor: '#F4F5F8',
    [theme.breakpoints.up('md')]: {
      width: 175,
      height: 175,
    },
  },
  avatarWrapper: {
    position: 'relative',
    top: 10,
    [theme.breakpoints.up('md')]: {
      top: -60,
    },
  },
  description: {
    color: '#58657C',
  },
}));

const StoreInfo = ({ bannerImage, storeName, storeDescription, storeImage }) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={classes.storeBanner}
        style={{
          backgroundImage: `url(${bannerImage || '/static/images/banner-placeholder.jpg'})`,
        }}
      ></div>
      <div className={classes.storeInfoWrapper}>
        <div className={classes.avatarWrapper}>
          <Avatar src={storeImage} className={classes.avatar} />
        </div>
        <div className={classes.storeContentWrapper}>
          <Typography variant="h1" gutterBottom>
            {storeName}
          </Typography>
          <Typography className={classes.description}>{storeDescription}</Typography>
        </div>
      </div>
    </>
  );
};

StoreInfo.propTypes = {
  bannerImage: PropTypes.string,
  storeName: PropTypes.string,
  storeDescription: PropTypes.string,
  storeImage: PropTypes.string,
};

export default StoreInfo;
